import React, {
    FunctionComponent,
    PropsWithChildren,
    useEffect
} from "react";

import {
    APILoadingStatus,
    APIProvider,
    APIProviderProps,
    useApiLoadingStatus,
    Map,
    MapProps
} from "@vis.gl/react-google-maps";

//based on https://visgl.github.io/react-google-maps/docs/guides/migrating-from-react-wrapper
const STATUS_MAP = {
    [APILoadingStatus.LOADING]: "LOADING",
    [APILoadingStatus.LOADED]: "SUCCESS",
    [APILoadingStatus.FAILED]: "FAILURE"
} as const;

type WrapperMapProps = {
    mapId?: string;
    onMapLoad?: (map: google.maps.Map) => void;
    onStatusChange?: (status: string) => void;
} & APIProviderProps & MapProps;

export type MapWrapperProps = PropsWithChildren<WrapperMapProps>;

export const MapWrapper: FunctionComponent<MapWrapperProps> = (props) => {
    const { apiKey, ...apiProps } = props;

    return (
        <APIProvider apiKey={apiKey} {...apiProps}>
            <InnerWrapper {...props}></InnerWrapper>
        </APIProvider>
    );
};

type InnerWrapperProps = PropsWithChildren<Omit<WrapperMapProps, "apiKey">>;

const InnerWrapper = (props: InnerWrapperProps) => {
    const status = useApiLoadingStatus();
    const mappedStatus = STATUS_MAP[status] ?? STATUS_MAP[APILoadingStatus.LOADING];

    const { defaultCenter, mapId, defaultZoom, className, children, renderingType, onStatusChange, onMapLoad } = props;

    useEffect(() => {
        if (onStatusChange) {
            onStatusChange(mappedStatus);
        }
    }, [onStatusChange, mappedStatus]);

    if (status !== APILoadingStatus.LOADED) {
        return null;
    }

    return (
        <Map
            {...props}
            // mapId={mapId}
            // defaultZoom={defaultZoom}
            // defaultCenter={defaultCenter}
            // renderingType={renderingType}
            styles={props.styles ? props.styles : undefined}
            className={className}>{children}
        </Map>
    );
}